import { reactive, ref, watch } from 'vue';
import type { ApiV1 } from '@teamworksdev/influencer/core';

interface UseContentHubLogoCrudDialogState {
	isOpen: boolean;
	isEditing: boolean;
	activeLogo: ApiV1.Sponsor | undefined;
	wasSuccessfullyMutated: boolean;
}

const DEFAULT_STATE: UseContentHubLogoCrudDialogState = {
	isOpen: false,
	isEditing: false,
	activeLogo: undefined,
	wasSuccessfullyMutated: false,
} as const;

const getDefaultState = () => ({ ...DEFAULT_STATE });

const state = reactive<UseContentHubLogoCrudDialogState>(getDefaultState());

function resetState() {
	Object.assign(state, getDefaultState());
}

const isRendered = ref<boolean>(false);

watch(() => state.isOpen, (isOpen) => {
	if (isOpen) {
		if (!isRendered.value) isRendered.value = true;
		return;
	}
	state.isEditing = false;
	state.activeLogo = undefined;
});

export function useContentHubLogoCrudDialog() {
	function open(sponsor?: ApiV1.Sponsor) {
		state.isEditing = !!sponsor;
		state.activeLogo = sponsor;
		state.isOpen = true;
		state.wasSuccessfullyMutated = false;
	}

	function markAsMutated() {
		state.wasSuccessfullyMutated = true;
	}

	return {
		state,
		open,
		markAsMutated,
		resetState,
		isRendered,
	};
}
